import React, { useEffect, useState } from 'react'
import { makeSideBarActive } from '../../utils/EllowUtils';
import SideMenu from '../sideMenu';
import DashboardHeader from '../topbar';
import * as CONSTANTS from "../../utils/CONSTANTS";
import Styles from "./styles.module.scss";
import Tab from "../../components/tab";
import { TabStripSelectEventArguments, TabStripTab, TabStrip } from "@progress/kendo-react-layout";
import PaymentTab from './paymentTab';
import CustomerBilling from './customerBilling';
import CandidateTimesheet from './candidateTimesheet';
import { useLocation } from 'react-router-dom';
import LeavesDetails from './leavesDetails';
import { paymentDetailsApi, getHistory , submitPaymentDetails } from './services'
import { postAPI } from '../../api/api';
import { REACT_APP_TIMESHEET } from '../../utils/common';
import NotificationAlert from "../../components/notification";




const CandidateTimesheetSettings = () => {

  const menu = makeSideBarActive(CONSTANTS.sideMenu, 4);
  const [selected, setSelected] = useState<number>(0);
  const location: any = useLocation().state

  const candidateData: any = JSON.parse(localStorage.getItem("CandidateTimesheetSettings") || "") || location && location.state
  const timesheetId: string = candidateData.timesheetId
  const projectId: string = candidateData.projectId
  const BreadcrumsValues = [" ", " ", " "]
  const [historyData, setHistoryData] = useState<any>()
  const [sort, setSort] = useState<any>([]);
  const [message, setMessage] = useState<string>('')
  const [notification, setNotification] = useState<boolean>(false)
  const [paymentDetails, setPaymentDetails] = useState<any>([]);
  const [timesheetDetails, setTimesheetDetails] = useState<any>([]);
  const [candidateDeductionDetails, setCandidateDeduction] = useState<any>([]);
  const [candidateArrearsDetails, setCandidateArrearsDetails] = useState<any>([]);
  const [customerArrearsDetails, setCustomerArrearsDetails] = useState<any>([]);
  const [customerDeductionDetails, setCustomerDeduction] = useState<any>([]);
  const [disabled , setDisabled] = useState<boolean>(false)
  
  useEffect(() => {
    getPaymentDetails(timesheetId, projectId)
    getHistoryDetails(timesheetId)
  }, [])

  const getHistoryDetails = (timesheetId: string) => {
    getHistory(timesheetId).then((response) => {
      if (response && response.status === 1) {
        setHistoryData(response.data)
      }
    })
  }

  const handleSelect = (e: TabStripSelectEventArguments) => {
    setSelected(e.selected);
  }

  const pageChange = (pageSize: number, pageNumber: number) => {
    let page = pageNumber !== 0 ? Math.floor(pageNumber / pageSize) + 1 : 1;
  }

  const getPaymentDetails = (timesheetId: string, projectId: string) => {
    paymentDetailsApi(timesheetId, projectId).then((resp: any) => {
      if (resp && resp.status === 1) {
        setPaymentDetails(resp.data[0].timesheetpayment)
        setTimesheetDetails(resp.data[0].timesheet[0].timesheetDetails)   
        let deductions = resp.data[0].candidateDeductions.filter((item: any) => item.percentage === 0)
        deductions.map((item: any) => item.type = 'Deduction')
        let additions = resp.data[0].candidateArrears
        additions.map((item: any) => item.type = 'Addition')
        let totalAdditionalInputs = [...deductions, ...additions]
        setCandidateDeduction(totalAdditionalInputs)
        setCandidateArrearsDetails(resp.data[0].candidateDeductions.filter((item: any) => item.percentage !== 0))
        let customerdeductions = resp.data[0].customerDeductions.filter((item: any) => item.percentage === 0)
        deductions.map((item: any) => item.type = 'Deduction')
        let customeradditions = resp.data[0].customerArrears
        additions.map((item: any) => item.type = 'Addition')
        let customertotalAdditionalInputs = [...customerdeductions, ...customeradditions]
        setCustomerDeduction(customertotalAdditionalInputs)
        setCustomerArrearsDetails(resp.data[0].customerDeductions.filter((item: any) => item.percentage !== 0))
      }
    })
  }

  const submitPayment = (data: any) => {
    setDisabled(true)
    submitPaymentDetails(data).then((resp: any) => {
      if (resp && resp.status === 1) {
        getPaymentDetails(timesheetId, projectId)
        setMessage("Details saved successfully")
        displayNotification()
        setDisabled(false)
      }else{
        setDisabled(false)
      }
    })
  }

  const displayNotification = () => {
    setNotification(true)
    setTimeout(() => {
      setNotification(false)
     }, 3000)  
  }

  const onClose = () => {
    setNotification(false)
  }

  return (
    <section className="dashboardWrapper">
      <SideMenu menu={menu} />
      {notification && <NotificationAlert onClose={onClose} closable={true} > {message} </NotificationAlert> }
      <div className="dashboardContent">
        <DashboardHeader
          title={false}
          applyFilter={false}
          searchChange={false}
          closeTag={false}
          name={candidateData.candidateName}
          role={candidateData.position}
          companyName={candidateData.companyName}
          timesheetStatus={candidateData.timesheetStatus}
          type='companyTimesheet'
        />
        <section className={Styles.positionWrapper}>
          <div className="transparentTabBlock">
            <TabStrip selected={selected} onSelect={handleSelect}>
              <Tab title={'Timesheet'}>
                <CandidateTimesheet candidateData={candidateData} timesheetId={candidateData.timesheetId} projectId={candidateData.projectId} historyData={historyData} />
              </Tab>
              <Tab title={'Payment'} >
                <PaymentTab candidateData={candidateData} DeductionDetails={candidateDeductionDetails}  arrearsDetails={candidateArrearsDetails} paymentDetails={paymentDetails} timesheetDetails={timesheetDetails} submitPayment={submitPayment} disable={disabled}/>
              </Tab>
              <Tab title={'Leaves details'}>
                <LeavesDetails candidateData={candidateData} total={1000} pageSize={pageChange} setSort={setSort} />
              </Tab>
              <Tab title={'Customer billing'}>
                <CustomerBilling candidateData={candidateData} DeductionDetails={customerDeductionDetails} arrearsDetails={customerArrearsDetails} paymentDetails={paymentDetails} timesheetDetails={timesheetDetails} submitPayment={submitPayment} />
              </Tab>
            </TabStrip>
          </div>
        </section>
      </div>
    </section>
  )
}

export default CandidateTimesheetSettings